import React, { useState, useEffect } from "react";
import { HiMenuAlt4, HiX } from "react-icons/hi";
import { motion } from "framer-motion";
import { images } from "../../constants";
import { client } from "../../client";

import "./Navbar.scss";

const Navbar = () => {
  const [download, setDownload] = useState([]);
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    const query = '*[_type == "download"]';

    client.fetch(query).then((data) => {
      setDownload(data);
    });
  }, []);

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <img src={images.logo} alt="Logo" />
      </div>
      <ul className="app__navbar-links">
        {["home", "about", "work", "skills", "contact"].map((item) => (
          <li className="app__flex p-text" key={`link-${item}`}>
            <div />
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
      </ul>

      {download.map((download, index) => (
        <a key={index} href={download.cvLink} target="blank">
          <button className="btn-navbar">Download CV</button>
        </a>
      ))}
      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={() => setToggle(true)} />

        {toggle && (
          <motion.div
            whileInView={{ x: [300, 0] }}
            transtition={{ duration: 0.85, ease: "easeOut" }}
          >
            <HiX onClick={() => setToggle(false)} />
            <ul>
              {["home", "about", "work", "skills", "contact"].map((item) => (
                <li key={item}>
                  <a href={`#${item}`} onClick={() => setToggle(false)}>
                    {item}
                  </a>
                </li>
              ))}
              {download.map((download, index) => (
                <a key={index} href={download.cvLink} target="blank">
                  <button className="btn-navbar">Download CV</button>
                </a>
              ))}
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
